<template>
  <table class="table m-0">
    <thead>
      <tr>
        <th class="d-sm-table-cell">Recurso</th>
        <th class="d-none d-sm-table-cell" style="width: 20%;">Limite</th>
        <th>Utilização</th>
        <th class="text-center d-none d-sm-table-cell" style="width: 15%;">Saldo Disponível</th>
        <th class="d-none d-sm-table-cell">Cobrança</th>
        <th class="d-none d-sm-table-cell"  v-if="!esconderBotaoAdicionar">Adicionar</th>
        <th class="d-none d-sm-table-cell" style="width: 10%;"  v-if="!esconderBotaoAdicionar">Saiba Mais</th>
      </tr>
    </thead>
    <tbody>
      <template v-if="recursos.length === 0">
        <tr>
          <td colspan="7" class="text-center">Nenhum recurso disponível.</td>
        </tr>
      </template>
      <template v-else v-for="(recurso, recurso_index) in recursos">
        <tr v-if="true" :key="recurso_index">
          <td @click="abrirCollapseMulti(recurso.descricao)" style="width: 25%; cursor:pointer;">
            <span
              :class="obterCollapseItems.includes(recurso.descricao) ? 'fa fa-arrow-down' : 'fa fa-arrow-right'"
              class="ms-2 p-2"
            ></span>
            {{ recurso.nome }}
          </td>
          <td class="d-none d-sm-table-cell" v-if="ehProdutoIlimitado(recurso.itens)">
            Ilimitado {{ recurso.nome }}
          </td>
          <td class="d-none d-sm-table-cell" v-else>
            {{ recurso.itens.limite }} {{ recurso.nome }}
          </td>
          <td style="width: 25%">
            <div class="row">
              <div :class="['col-12', 'd-block', 'd-sm-block', 'd-lg-none', 'd-xl-none', 'd-md-none']">
                <span class="text-nowrap text-truncate" v-if="ehProdutoIlimitado(recurso.itens)">{{ recurso.itens.utilizado }} / Ilimitado</span>
                <span v-else>{{ recurso.itens.utilizado }} / {{ recurso.itens.limite }}</span>
              </div>
              <div :class="['col-5', 'd-none', 'd-sm-none', 'd-lg-block', 'd-xl-block', 'd-md-block']">
                <span class="text-nowrap text-truncate" v-if="ehProdutoIlimitado(recurso.itens)">{{ recurso.itens.utilizado }} / Ilimitado</span>
                <span v-else>{{ recurso.itens.utilizado }} / {{ recurso.itens.limite }}</span>
              </div>
              <div class="col-7 d-none d-sm-none d-lg-block d-xl-block d-md-block">
                <div class="progress flex-grow-1 mx-2 progress-custom" v-if="!ehProdutoIlimitado(recurso.itens)">
                  <div
                    class="progress-bar bg-danger"
                    role="progressbar"
                    :style="{ width: (recurso.itens.utilizado / recurso.itens.limite) * 100 + '%' }"
                  ></div>
                  <div
                    class="progress-bar bg-success"
                    role="progressbar"
                    :style="{ width: (recurso.itens.saldo / recurso.itens.limite) * 100 + '%' }"
                  ></div>
                </div>
              </div>
            </div>
          </td>
          <td
            class="d-none d-sm-table-cell text-center"
          >
            <span v-if="ehProdutoIlimitado(recurso.itens)">Ilimitado</span>
            <span v-else>
              {{ recurso.descricao === 'armazenamento' ? recurso.itens.saldo + 'GB' : recurso.itens.saldo }}
            </span>
          </td>
          <td
            class="d-none d-sm-table-cell"
            v-if="recurso.tipo === 1"
          >
            Mensal
          </td>
          <td
            class="d-none d-sm-table-cell"
            v-if="recurso.tipo === 2"
          >
            Único
          </td>
          <td class="d-none d-sm-table-cell" v-if="!esconderBotaoAdicionar">
            <router-link
              :to="{ name: 'mercado', params: { idProduto: recurso.produto_id } }"
              class="btn btn-primary btn-custom mobile-button"
            >
              Adicionar
            </router-link>
          </td>
          <td class="d-none d-sm-none d-sm-table-cell"  v-if="!esconderBotaoAdicionar">
            <router-link
              :to="{ name: 'mercado', params: { idProduto: recurso.produto_id } }"
              class="btn btn-link text-decoration-none action"
            >
              Saiba Mais
            </router-link>
          </td>
        </tr>

        <!-- Linha colapsável dentro do mesmo v-for -->
        <tr
          v-if="obterCollapseItems.includes(recurso.descricao)"
          :key="`collapsed-${recurso_index}`"
        >
          <td colspan="7" style="padding: 30px; background-color: #F0F0F0;">
            <table class="table table-sm mb-0">
              <thead>
                <tr>
                  <th>Serviço</th>
                  <th class="d-none d-sm-table-cell text-center">Quantidade</th>
                  <th class="d-none d-sm-table-cell">Valor Unitário</th>
                  <th class="d-none d-sm-table-cell">Valor Total</th>
                  <th class="d-none d-sm-table-cell text-center">Total Disponibilizado</th>
                  <th class="d-none d-sm-table-cell" v-if="recurso.tipo === 1">Dt. Cadastro</th>
                  <th class="d-sm-block d-lg-none d-xl-none d-md-none d-sm-table-cell text-center">Total</th>
                  <th class="d-none d-sm-table-cell" v-if="!esconderBotaoCancelar && recurso.tipo !== 2"></th>
                  <th class="d-none d-sm-table-cell" v-if="recurso.tipo === 2">Dt. Validade</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(subItem, subitem_index) in recurso.itens.sub_itens" :key="subitem_index">
                  <td>{{ subItem.plano_nome }}</td>
                  <td class="d-none d-sm-table-cell text-center"> {{ !subItem.ilimitado ? subItem.quantidade : 'Ilimitado' }}</td>
                  <td class="d-none d-sm-table-cell">{{ formatarValorMonetario(subItem.valor) || '0,00' }}</td>
                  <td class="d-none d-sm-table-cell">{{ formatarValorMonetario(subItem.valor_total) || '0,00'}}</td>
                  <td class="d-none d-sm-table-cell text-center">{{ !subItem.ilimitado ? subItem.quantidade_item : 'Ilimitado' }}</td>
                  <td class="d-sm-block d-lg-none d-xl-none d-md-none d-sm-table-cell text-center">{{ !subItem.ilimitado ? subItem.quantidade_item : 'Ilimitado' }}</td>
                  <td
                    class="d-none d-sm-table-cell"
                    v-if="recurso.tipo === 1"
                  >
                    {{ $date(subItem.data_cadastro).format('DD/MM/YYYY') }}
                  </td>
                  <td
                    class="d-none d-sm-table-cell"
                    v-if="!esconderBotaoCancelar && recurso.tipo === 1 && subItem.valor > 0 && subItem.produto_id !== 7"
                  >
                    <button
                      @click="
                        modalVerificaCancelamento.abrirModalVerificaCancelamento(
                          subItem.contrato_id,
                          '0',
                          subItem
                        )
                      "
                      class="btn btn-link text-decoration-none action"
                    >
                      Cancelar
                    </button>
                  </td>
                  <td
                    class="d-none d-sm-table-cell"
                    v-if="recurso.tipo === 2"
                  >
                    {{ $date(subItem.data_validade).format('DD/MM/YYYY') }}
                  </td>
                </tr>
                <tr v-if="!esconderBotaoAdicionar" :key="recurso_index + '_item'">
                  <td class="d-xl-none d-lg-none d-md-none"  colspan="100" v-if="!esconderBotaoAdicionar">
                    <router-link
                      :to="{ name: 'mercado', params: { idProduto: recurso.produto_id } }"
                      class="btn btn-primary col-12  btn-custom mobile-button"
                    >
                      Adicionar
                    </router-link>
                  </td>
                </tr>
              </tbody>
            </table>
          </td>
        </tr>
      </template>
    </tbody>
  </table>
</template>

<script>
import RecursosListagem from './js/recursos-listagem'
export default RecursosListagem
</script>

<style scoped>
@import "./scss/recurso.scss";
</style>
